import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  DateFundFilterDialog,
  FormInput,
  ModelForm,
  SelectData,
} from '../../../shared/models';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import moment from 'moment';

interface DateFundFilter {
  actionButton: string;
  title: string;
  fields: FormInput[];
}

@Component({
  selector: 'filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss'],
})
export class FilterDialogComponent implements OnInit {
  formGroup: FormGroup<ModelForm<DateFundFilterDialog>> = new FormGroup({});
  private destroySubject: Subject<boolean> = new Subject();

  constructor(
    private dialogRef: MatDialogRef<FilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DateFundFilter
  ) {}

  ngOnInit(): void {
    this.formGroup.reset();
    const { fields } = this.data;
    if (fields?.length) {
      fields.forEach((field) => {
        this.formGroup.addControl(
          field.formControlName,
          new FormControl(null, field.required ? [Validators.required] : [])
        );
      });
      this.formGroup.updateValueAndValidity();
    }

    this.registerDateEndObserver();
    this.registerFundObserver();
  }

  filter(): void {
    this.dialogRef.close(this.formGroup.getRawValue());
  }

  private registerFundObserver(): void {
    if (!this.formGroup.get('fundId')) {
      return;
    }
    this.formGroup
      .get('fundId')
      ?.valueChanges.pipe(takeUntil(this.destroySubject))
      .subscribe((selectedFund: SelectData) => {
        if (selectedFund && selectedFund.value?.data) {
          const fundDate = moment(selectedFund.value.data);
          const newDate = new Date(
            fundDate.subtract(0, 'day').format('YYYY-MM-DD')
          );
          this.formGroup.get('dataFim')?.setValue(newDate);
        }
      });
  }

  private registerDateEndObserver(): void {
    if (
      !this.formGroup.controls['dataFim'] ||
      !this.formGroup.controls['date']
    ) {
      return;
    }

    this.formGroup.controls['date'].valueChanges
      .pipe(takeUntil(this.destroySubject))
      .subscribe((value: Date) => {
        const dataFimControl = this.formGroup.controls['dataFim'];
        if (dataFimControl) {
          dataFimControl.updateValueAndValidity();
        }

        const dataFimIndex = this.data.fields.findIndex(
          (field) => field.formControlName === 'dataFim'
        );
        if (dataFimIndex !== -1) {
          this.data.fields[dataFimIndex].minDate = value;
          this.data.fields = [...this.data.fields];
        }
      });
  }
}
